import {
  Button,
  Col,
  Divider,
  Form,
  Popover,
  Row,
  Space,
  Spin,
  Table,
  Typography,
  message,
} from "antd";
import {CreateReceiptSVG, ExcelSVG, ListIconSVG} from "assets";
import icons from "assets/icons";
import {ButtonExcel, InputFields, ListActionButton} from "components/common";
import ColumnPopoverDisplay from "components/common/PopoverTable/PopoverTable";
import React, {useEffect, useMemo, useState} from "react";
// import { createTicketModalColumns } from "types/config/colums-ctreate-ticket-modal";
import {columns as columnsInit, fields as fieldsInit} from "./config";
import {ColumnProps} from "types/models";
import {glassStoreService} from "api";
import {useAppDispatch, useAppSelector} from "redux/hooks";

import Notification from "components/common/notification/notification";
import {
  exportFile,
  formatDateToString,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import Icon from "assets/icons";
import {TableRowSelection} from "antd/es/table/interface";
import {
  getListStore,
  getListStorePhanQuyen,
  getListSupplierAPI,
  setSelectedRecord,
  setTypeForm,
  setTypePhieu,
} from "redux/reducer/glassStore";
import {setActiveKey} from "redux/reducer/common";
import {FORMAT_TIME, LOAI_FORM, LOAI_PHIEU_KHO, tabKeys} from "types/enums";
import moment from "moment";
import dayjs from "dayjs";
import {RangePickerProps} from "antd/es/date-picker";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
const ImportExport = () => {
  let savedTableOption = getTableOptions(
    "GLASS_IMPORT_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? columnsInit.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : columnsInit;
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [dataTable, setDataTable] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [limit, setLimit] = useState<number>(10);
  const [totalPage, setTotalPage] = useState();
  const [fields, setFields] = useState(fieldsInit);
  const dispatch = useAppDispatch();
  const glassStore = useAppSelector(state => state.glassStore);
  const [params, setParams] = useState<any>({
    page: currentPage,
    limit: limit,
    loaiPhieu: LOAI_PHIEU_KHO.NHAP,
    start: formatDateToString(moment(), FORMAT_TIME.dayFull),
    end: formatDateToString(moment(), FORMAT_TIME.dayFull),
    // ...form.getFieldsValue(),
  });
  useEffect(() => {
    form.setFieldValue("start", dayjs());
    form.setFieldValue("end", dayjs());
  }, []);
  const [columns, setColumns] = useState(
    defaultColumns.filter(e => e.show === true)
  );
  const activeTab = useAppSelector(e => e.common.activeTab);
  const selectedRecord = useAppSelector(
    state => state.glassStore.selectedRecord
  );

  useEffect(() => {
    if (activeTab == tabKeys.GLASSES_STOREHOUSE.IMPORT) {
      if (
        localStorage.getItem("khoUserGlassId") &&
        form.getFieldValue("khoNhapId") == null
      ) {
        form.setFieldValue(
          "khoNhapId",
          Number(localStorage.getItem("khoUserGlassId")) || null
        );
        setParams({
          ...params,
          khoNhapId: Number(localStorage.getItem("khoUserGlassId")) || null,
        });
      }
      getList();
    }
  }, [activeTab]);
  useEffect(() => {
    dispatch(getListSupplierAPI(1, 100));
  }, []);
  useEffect(() => {
    dispatch(getListStorePhanQuyen());
  }, [activeTab]);

  useEffect(() => {
    if (glassStore.listStore) {
      setOptionsStore(glassStore.listStore);
    }
  }, [glassStore.listStore]);
  useEffect(() => {
    setOptionsSupplier(glassStore.listSupplier);
  }, [glassStore.listSupplier]);
  const setOptionsStore = listStore => {
    const options = listStore.map(e => ({value: e.id, label: e.name}));
    fieldsInit.find(e => e.name == "khoNhapId").options = options;

    setFields([...fields]);
  };
  const setOptionsSupplier = listSupplier => {
    const options = listSupplier.map(e => ({value: e.id, label: e.name}));
    fieldsInit.find(e => e.name == "nhaCungCapId").options = options;

    setFields([...fields]);
  };
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
      const endDay = form.getFieldValue("end");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
      const start = form.getFieldValue("start");
      if (start) {
        return currentDate < start;
      }
    };
    fieldsInit.find(e => e.name == "start").disabledDate = disabledDateStart;
    fieldsInit.find(e => e.name == "end").disabledDate = disabledDateEnd;
    setFields([...fieldsInit]);
  }, []);
  // cau hinh api khi thay doi trang thai phieu khi submit
  const getList = async () => {
    setSelectedRowKeys([]);
    setLoading(true);
    try {
      const res = await glassStoreService.getListReceipt(params);

      setDataTable(res.data.map(e => ({...e, key: e.id})));
      setLoading(false);
      setTotalPage(res.total);
    } catch (error) {
      setLoading(false);
    }
  };
  useMemo(() => {
    getList();
  }, [currentPage, params]);

  //tạo phiếu nhập
  const createPhieu = () => {
    dispatch(setTypeForm(LOAI_FORM.TAO_MOI));
    dispatch(setTypePhieu(LOAI_PHIEU_KHO.NHAP));
    navigateTab();
  };

  const navigateTab = () => [
    dispatch(setActiveKey(tabKeys.GLASSES_STOREHOUSE.DETAIL)),
  ];

  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    saveTableOptions(
      "GLASS_IMPORT_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  const onClickSearch = () => {
    const formValue = form.getFieldsValue();
    let searchFields = {
      ...formValue,
      start: formatDateToString(formValue.start, FORMAT_TIME.dayFull) ?? null,
      end: formatDateToString(formValue.end, FORMAT_TIME.dayFull) ?? null,
    };
    setParams({...params, ...searchFields, page: 1});
  };

  const handlePaginationChange = (page, pageSize?: number) => {
    setParams({...params, page: page, limit: pageSize});
  };

  //cấu hình trang cho bảng
  const paginationConfig = {
    // trang hiện tại
    total: totalPage, // tổng số phần tử
    // pageSize: limit,
    showSizeChanger: true,
    onChange: handlePaginationChange,
  };

  const handleOnReload = () => {
    form.resetFields();
    onClickSearch();
  };

  const viewDeTailPhieu = () => {
    if (selectedRecord?.loaiPhieu == LOAI_PHIEU_KHO.NHAP) {
      dispatch(setTypeForm(LOAI_FORM.DA_TAO));
      dispatch(setTypePhieu(LOAI_PHIEU_KHO.NHAP));
      navigateTab();
    } else {
      Notification("warning", "Chưa chọn phiếu nhập");
    }
  };

  const onSelectChange = (
    selectedRowKeys: React.Key[],
    selectedRows: any[]
  ) => {
    setSelectedRowKeys(selectedRowKeys);
    dispatch(setSelectedRecord(selectedRows[0]));
  };

  const rowRadio: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
    type: "radio",
  };
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  const getReportFile = async () => {
    const data = {
      start: params?.start,
      end: params?.end,
      khoId: form.getFieldValue("khoNhapId"),
      loaiPhieu: LOAI_PHIEU_KHO.NHAP,
      nhomPhieu: "KI",
      status: params?.status,
    };
    if (data?.khoId == null) {
      Notification("warning", "Chưa chọn kho");
    } else if (!data?.start) {
      Notification("warning", "Chưa chọn ngày tạo từ");
    } else if (!data?.end) {
      Notification("warning", "Chưa chọn ngày tạo đến");
    } else {
      const nameFile = `Báo cáo xuất nhập kho ${data?.start} - ${data?.end}`;
      exportFile("store/receipt/export-thong-ke-nhap-xuat-kho", data, nameFile);
    }
  };
  return (
    <div className="import-glass" onKeyDown={onKeyDown} tabIndex={0}>
      {/* thong tin */}

      {/* tìm kiếm */}
      <div className="container">
        <Form form={form} labelAlign="left">
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 8]}>
              <InputFields data={fields} />
            </Row>
            <Row justify={"end"}>
              <Space>
                <Button
                  type="ghost"
                  className="btn-sub"
                  icon={<Icon.reload rev={0} />}
                  onClick={handleOnReload}
                >
                  Xoá tìm kiếm
                </Button>
                <Button
                  type="primary"
                  icon={<icons.search rev={0} />}
                  onClick={onClickSearch}
                >
                  Tìm kiếm
                </Button>
              </Space>
            </Row>
          </Space>
        </Form>
      </div>

      {/* Danh sách phiếu nhập xuất */}
      <div className="container">
        <Space style={{width: "100%"}} direction="vertical" size={"small"}>
          <Typography.Text strong ellipsis={true}>
            Danh sách phiếu nhập
          </Typography.Text>
          <Divider style={{margin: 4}} />
          <Row gutter={[16, 16]} justify={"end"}>
            <Col>
              <Space>
                <ButtonExcel onClick={getReportFile}></ButtonExcel>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={defaultColumns}
                    />
                  }
                >
                  <Button
                    type="ghost"
                    icon={<ListIconSVG />}
                    className="btn-sub"
                  >
                    Cột hiển thị
                  </Button>
                </Popover>

                <Button
                  type="ghost"
                  className="btn-sub"
                  onClick={createPhieu}
                  icon={<CreateReceiptSVG />}
                >
                  Tạo phiếu nhập
                </Button>

                <Button
                  type="ghost"
                  className="btn-sub"
                  onClick={viewDeTailPhieu}
                >
                  Chi tiết phiếu
                </Button>
              </Space>
            </Col>
          </Row>
          <CustomResizableTable
            setShowColumns={setShowColumns}
            bordered
            dataSource={dataTable}
            // className="custom-resize-table-scroll"
            columns={columns}
            // scroll={{x: 2500}}
            loading={loading}
            pagination={paginationConfig}
            rowSelection={rowRadio}
            onRow={record => ({
              onDoubleClick: () => {
                dispatch(setSelectedRecord(record));
                dispatch(setTypeForm(LOAI_FORM.DA_TAO));
                dispatch(setTypePhieu(LOAI_PHIEU_KHO.NHAP));
                navigateTab();
              },
            })}
          />
        </Space>
      </div>
    </div>
  );
};

export default ImportExport;
